export const translateDocumentType = (type: string) => {
  const convertedType = type.toLowerCase();

  if (convertedType === "renseigneringsbrief") {
    return "Fiscale waarde van de verzekering";
  }

  if (convertedType === "aanbieding") {
    return "Polis";
  }

  return type;
};
